export enum AppRoute {
  PullRequest = 'pull-request',
  PageNotFound = 'page-not-found',
  Share = 'share',
  Login = 'login',
  Documents = 'documents',
}

export enum AppRouteParam {
  BusinessUnit = 'businessUnit',
}

export enum AppRouteQueryParam {
  Culture = 'culture',
  ShareId = 'shareId',
  RelationId = 'relationId',
}
